import {
  CreateKEKEndorsementOffer,
  CreateKEKEndorsementOfferVariables,
} from "_graphql/kek/mutation/__generated__/CreateKEKEndorsementOffer";

import { StepFormBuilder } from "../..";
import _ from "lodash";
import { createEndorsementFormItems } from "./form-steps";
import { createKEKEndorsement } from "_graphql/kek/mutation/index.kek";
import toast from "react-hot-toast";
import { useCurrentUser } from "_graphql/cache/auth";
import { useFormik } from "formik";
import { useMutation } from "@apollo/client";

type Props = {
  setClose?: (value: boolean) => void;
};

const EndorsementFormKEKContainer = ({ setClose }: Props) => {
  const user = useCurrentUser();
  const [createEndorsement] = useMutation<
    CreateKEKEndorsementOffer,
    CreateKEKEndorsementOfferVariables
  >(createKEKEndorsement, {
    refetchQueries: ["GetKEKEndorsements"],
  });
  const form = useFormik<any>({
    initialValues: {
      offer: {
        offer: "",
      },
      details: {
        class_of_business_id: "",
        offer_details: [],
        insurer_id: "",
        premium: "",
        policy_number: "",
        insured_by: "",
        sum_insured: "",
        rate: "",
        facultative_offer: "",
        commission: "",
        brokerage: "",
        currency: "",
        period_of_insurance_from: "",
        period_of_insurance_to: "",
        co_insurance_share: "",
        comment: "",
        information_comment: "",
        business_state: "",
        payment_type: "",
        reinsurer_id: "",
        ex_currency: "",
        ex_rate: "",
      },
    },
    onSubmit: async (values) => {
      await createEndorsement({
        variables: {
          offerInput: {
            offer_comment: values?.details?.comment || "",
            offer_details: JSON.stringify(values.details.old_offer_detail),
            ...(_.omit(values.details, [
              "old_class_of_business_id",
              "old_offer_detail",
              "comment",
              "offer_details",
              "payment_type",
              "no_of_installments",
              "include_nkrol_comment",
              "addExchangeRate",
            ]) as any),
            employee_id: user?.employee?.employee_id ?? "",
            payment_type: {
              [values.payment_type]:
                values.payment_type === "payable_in_full"
                  ? "Facultative Premium payable in full at inception"
                  : values.no_of_installments,
            },
          },
          offerId: values?.offer?.exisitingOffer?.offer_id,
        },
      }).then((res) => {
        if (res.data?.createEndorsementOffer) {
          toast.success("Endorsement Created Successfully");
          setClose?.(false);
        }
      });
    },
  });

  return (
    <StepFormBuilder
      formSteps={createEndorsementFormItems}
      form={form}
      setOpen={setClose}
    />
  );
};

export default EndorsementFormKEKContainer;
